import { render, staticRenderFns } from "./CoreNavigation.vue?vue&type=template&id=10f9a431&scoped=true&"
import script from "./CoreNavigation.vue?vue&type=script&lang=js&"
export * from "./CoreNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CoreNavigation.vue?vue&type=style&index=0&id=10f9a431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9a431",
  null
  
)

export default component.exports